var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export function getUrlParam(param, defaultValue) {
    var _a;
    return (param ? (Array.isArray(param) ? ((_a = param.find(function (p) { return !!p; })) !== null && _a !== void 0 ? _a : '') : param).trim() : (defaultValue !== null && defaultValue !== void 0 ? defaultValue : ''));
}
export function makeUrlParams(prefix, params) {
    if (prefix === void 0) { prefix = ''; }
    var hasSeparators = decodeURIComponent(prefix).includes('?');
    var hasPrepend = !hasSeparators || (hasSeparators && !prefix.endsWith('?'));
    if (params) {
        return Object.entries(params).reduce(function (acc, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            var param = acc;
            if (value !== null && value !== undefined) {
                var prefix_1 = hasPrepend ? (hasSeparators ? '&' : '?') : '';
                param += "".concat(prefix_1).concat(key, "=").concat(value ? encodeURIComponent(value) : '');
                hasSeparators = true;
                hasPrepend = true;
            }
            return param;
        }, prefix);
    }
    return prefix;
}
//# sourceMappingURL=url.js.map